document.addEventListener('DOMContentLoaded', function () {
  // Helper: parse "$18.95 USD" → 18.95
  function parseMoney(text) {
    if (!text) return null;
    var num = text.replace(/[^0-9.\-]/g, '');
    var val = parseFloat(num);
    return isNaN(val) ? null : val;
  }

  function updateBadges(context) {
    // Find all price wrappers on the page (product & collection cards)
    var priceWrappers = context.querySelectorAll('.price');

    priceWrappers.forEach(function (wrapper) {
      var regularEl = wrapper.querySelector('.price-item--regular');
      var saleEl    = wrapper.querySelector('.price-item--sale');

      if (!regularEl || !saleEl) return;

      var regular = parseMoney(regularEl.textContent);
      var sale    = parseMoney(saleEl.textContent);

      if (!regular || !sale || regular <= 0 || sale >= regular) return;

      // Raw discount %
      var raw = ((regular - sale) / regular) * 100;

      // Round to nearest 5 (same idea as Liquid: +2 then /5 *5)
      var display = Math.round((raw + 2) / 5) * 5;

      // Find the badge for this product/card
      // Try closest .custom-sale-badge inside the same card/section
      var badge =
        wrapper.closest('.card, .product, .product__info-wrapper')?.querySelector('.custom-sale-badge') ||
        wrapper.querySelector('.custom-sale-badge');

      if (badge) {
        badge.textContent = display + '% OFF';
      }
    });
  }

  updateBadges(document);
});
